import { CardGroupType, CardType, ComponentItem, EyebrowProps, FormProps } from '~types'
import { isComponentOfType } from 'utils'

export const enhanceComponentBlock = (block: ComponentItem, isChildOfModal: boolean = false): ComponentItem => {
  if (!block) return block

  const enhancedData: ComponentItem = {
    ...block,
    ...(isComponentOfType<EyebrowProps>(block, 'Eyebrow') && {
      color: block.eyebrowColor,
      size: block.eyebrowSize
    }),
    ...(isChildOfModal &&
      isComponentOfType<FormProps>(block, 'Form') && {
        isChildOfModal: true
      }),
    // Move Card `ctas` inside `buttonGroup`
    ...(isComponentOfType<CardType>(block, 'Card') &&
      // Prevent overwrite upon future migration
      !block?.buttonGroup && {
        buttonGroup: {
          buttons: block?.ctas || []
        }
      }),
    // Recursively enhance CardGroup children
    ...(isComponentOfType<CardGroupType>(block, 'CardGroup') && {
      cards: block.cards?.map(card => enhanceComponentBlock(card))
    })
  }
  return enhancedData
}
